import { MetaMaskConnector } from "wagmi/connectors/metaMask";

export const metamaskConnector = new MetaMaskConnector();
